import { render, staticRenderFns } from "./LabelViewGlobal.vue?vue&type=template&id=50623992"
import script from "./LabelViewGlobal.vue?vue&type=script&lang=js"
export * from "./LabelViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports